module.exports = __webpack_public_path__ + "a990eb201a9c517837de549381b94eb0.MP3";